import { Box, Typography, TextField, Checkbox, FormControlLabel, Link, IconButton, RadioGroup, Radio } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import ReusableChip from "../../components/reusableComponents/chipSelector";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import { useState } from 'react';
import CustomTabs from '../../components/reusableComponents/CustomTabs';
import RejectReason from '../../components/reusableComponents/RejectReason';

const ContentBox = ({ title, children }) => (
    <Box sx={{ backgroundColor: "#fff", borderRadius: 2, boxShadow: 1, marginTop: '16px', p: 3 }}>
        <Typography sx={{ color: "#7A7A7A", fontWeight: 600, mb: 1, fontSize: '18px' }}>{title}</Typography>
        {children}
    </Box>
);

const TabsGigApplicationData = ({
    activeTab,
    applicationData,
    handleApprovePitch,
    handleRejectPitch,
    handleApproveDeliverable,
    handleRejectDeliverable,
    handleRequestChangesClick,
    handleSendFeedback,
    showFeedbackBox,
    setShowFeedbackBox,
    feedbackText,
    setFeedbackText,
    feedbackSentIndexes,
    expandedIndexes,
    toggleExpand,
    submittedFeedbackTexts,
    formatDateTime,
    isValidMap,
    setIsValidMap,
    reasonMap,
    setReasonMap,
    activeTabs,
    setActiveTabs,
    handleSave,
    loading,
    loadingMap,
    showRejectFeedbackBox,
    setShowRejectFeedbackBox,
    rejectFeedbackText,
    setRejectFeedbackText
}) => {
    const [expandedLiveIndexes, setExpandedLiveIndexes] = useState([]);
    const [showRejectReasonBox, setShowRejectReasonBox] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherMessage, setOtherMessage] = useState("");
    const [savedReasons, setSavedReasons] = useState({});
    const [errors, setErrors] = useState({
        feedbackText: "",
        rejectFeedbackText: "",
        reasonMap: {}
    });
    const hasUpdatedSubmission = Array.isArray(applicationData?.live_links)
        && applicationData.live_links.some(link => link?.child);
    const localTabs = hasUpdatedSubmission
        ? ["Submission", "Updated Submission"]
        : ["Submission"];

    const onSendFeedback = (index) => {
        if (!feedbackText.trim()) {
            setErrors((prev) => ({ ...prev, feedbackText: "Reason is required" }));
            return;
        }
        setErrors((prev) => ({ ...prev, feedbackText: "" }));
        handleSendFeedback(index);
    };

    const onRejectDeliverable = (index) => {
        if (!rejectFeedbackText.trim()) {
            setErrors((prev) => ({ ...prev, rejectFeedbackText: "Reason is required" }));
            return;
        }
        setErrors((prev) => ({ ...prev, rejectFeedbackText: "" }));
        handleRejectDeliverable(index);
    };

    const handleRejectButtonClick = () => {
        setShowRejectFeedbackBox(true);
    };

    const handleCheckboxChange = (reason) => {
        setSelectedReasons((prev) =>
            prev.includes(reason)
                ? prev.filter((r) => r !== reason)
                : [...prev, reason]
        );
    };

    const handleRejectClick = () => {
        setShowRejectReasonBox(true);
    };

    const confirmRejectPitch = () => {
        handleRejectPitch(selectedReasons, otherMessage);
        setShowRejectReasonBox(false);
        setSelectedReasons([]);
        setOtherMessage("");
    };

    const cancelReject = () => {
        setShowRejectReasonBox(false);
    };

    const handleValidityChange = (id, value) => {
        setIsValidMap((prev) => ({ ...prev, [id]: value }));
        if (value === "Yes") {
            handleSave(id, value);
        }
    };

    const handleReasonChange = (id, value) => {
        setReasonMap((prev) => ({ ...prev, [id]: value }));
    };

    const handleSaveReason = (id, index) => {
        const reason = reasonMap[id];
        if (!reason || !reason.trim()) {
            setErrors((prev) => ({
                ...prev,
                reasonMap: { ...prev.reasonMap, [id]: "Reason is required" }
            }));
            return;
        }
        setErrors((prev) => ({
            ...prev,
            reasonMap: { ...prev.reasonMap, [id]: "" }
        }));
        setSavedReasons((prev) => ({ ...prev, [id]: reason }));
        handleSave(id, "No");
    };

    const toggleLiveExpand = (index) => {
        setExpandedLiveIndexes(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const renderTabContent = () => {
        if (activeTab === "pitch") {
            const approveBtn = {
                backgroundColor: '#219653 !important',
                border: 'none !important',
            };
            const isPitchFinalized = applicationData?.Status === "approved" || applicationData?.Status === "rejected";
            return (
                <Box>
                    <ContentBox title="Application Pitch">
                        <Box sx={{
                            borderLeft: "4px solid #F14950",
                            backgroundColor: "#fafafa",
                            p: 2,
                            pl: 2,
                            borderRadius: "8px",
                            mb: 3
                        }}>
                            <Typography variant="body2" sx={{ color: "#666", lineHeight: 1.6, mb: 1 }}>
                                {applicationData?.pitch}
                            </Typography>

                            {applicationData?.assesment_link && (
                                <a href={applicationData?.assesment_link} target="_blank" rel="noopener noreferrer">
                                    <ReusableButton
                                        variant="contained"
                                        children={"Media Kit"}
                                        endIcon={<ReusableMuiIcons name="launch" />}
                                        classNames="gn-actionbtn"
                                        sx={{ textTransform: 'none' }}
                                    />
                                </a>
                            )}
                        </Box>

                        {!isPitchFinalized && !showRejectReasonBox && (
                            <Box display="flex" gap={2}>
                                <ReusableButton
                                    variant="contained"
                                    classNames="gn-actionbtn"
                                    onClick={handleRejectClick}
                                    loader={loading.rejectPitch}
                                    disabled={loading.rejectPitch || loading.approvePitch}
                                >
                                    Reject
                                </ReusableButton>
                                <ReusableButton
                                    variant="contained"
                                    classNames="gn-actionbtn"
                                    sx={approveBtn}
                                    onClick={handleApprovePitch}
                                    loader={loading.approvePitch}
                                    disabled={loading.rejectPitch || loading.approvePitch}
                                >
                                    Approve
                                </ReusableButton>
                            </Box>
                        )}

                        {showRejectReasonBox && (
                            <Box mt={2}>
                                <RejectReason
                                    handleCheckboxChange={handleCheckboxChange}
                                    handleReject={confirmRejectPitch}
                                    setOtherMessage={setOtherMessage}
                                    selectedReasons={selectedReasons}
                                    otherMessage={otherMessage}
                                    onClose={cancelReject}
                                />
                            </Box>
                        )}
                    </ContentBox>
                </Box>
            );
        }

        if (activeTab === "deliverable") {
            const isSubmissionFinalized = (status) =>
                ["approved", "rejected", "need-changes"].includes(status?.toLowerCase());
            const approveBtn = {
                backgroundColor: '#219653 !important',
                border: 'none !important',
            };
            const submissions = [];
            const parentDeliverable = applicationData?.deliverables_links?.[0];
            const childDeliverable = parentDeliverable?.child;

            if (parentDeliverable) {
                submissions.push({
                    id: parentDeliverable.id,
                    link: parentDeliverable.deliverable_link,
                    submittedAt: parentDeliverable.created_at,
                    status: parentDeliverable.deliverable_status?.toLowerCase(),
                    reason: parentDeliverable.deliverable_reason,
                });
            }

            if (parentDeliverable?.deliverable_status === "Need-changes" && childDeliverable) {
                submissions.push({
                    id: childDeliverable.id,
                    link: childDeliverable.deliverable_link,
                    submittedAt: childDeliverable.created_at,
                    status: childDeliverable.deliverable_status?.toLowerCase(),
                    reason: childDeliverable.deliverable_reason,
                });
            }

            return (
                <ContentBox title="Submission Rounds">
                    {submissions.map((submission, i) => {
                        const isFeedbackSent = feedbackSentIndexes.includes(i);
                        const isExpanded = expandedIndexes.includes(i);
                        const isFinal = isSubmissionFinalized(submission.status);
                        return (
                            <Box key={i} sx={{ backgroundColor: "#f7f7f7", p: 2, borderLeft: "4px solid #F14950", borderRadius: "8px", mb: 2 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            {(isFeedbackSent || (i === 0 && parentDeliverable?.deliverable_reason) || (i !== 0 && submission.reason)) && (
                                                <IconButton size="small" onClick={() => toggleExpand(i)} sx={{ p: 0 }}>
                                                    {isExpanded ? <ExpandLess /> : <ExpandMore />}
                                                </IconButton>
                                            )}
                                            <Typography sx={{ fontSize: "14px", color: "#7A7A7A" }}>
                                                Submission {i + 1}
                                            </Typography>
                                        </Box>

                                        <Link href={submission.link} target="_blank" rel="noopener" sx={{ mb: 1, display: "inline-block", textDecoration: "none", fontSize: "16px", }} >
                                            <ReusableMuiIcons name={"launch"} sx={{ color: "#7A7A7A" }} /> {submission.link}
                                        </Link>

                                        <Typography display="block" sx={{ mb: 1, color: "#7A7A7A", fontSize: "12px" }} >
                                            Submitted: {formatDateTime(submission.submittedAt)}
                                        </Typography>
                                    </Box>

                                    {(isFinal || submission.status === "need-changes") && (
                                        <ReusableChip
                                            label={
                                                submission.status === "approved"
                                                    ? "Approved"
                                                    : submission.status === "rejected"
                                                        ? "Rejected"
                                                        : "Need Changes"
                                            }
                                            bgcolor={
                                                submission.status === "approved"
                                                    ? "#E0F7EA"
                                                    : submission.status === "rejected"
                                                        ? "#FFEBEB"
                                                        : "#FFE3E4"
                                            }
                                            color={
                                                submission.status === "approved"
                                                    ? "#219653"
                                                    : submission.status === "rejected"
                                                        ? "#F14950"
                                                        : "#EF5A56"
                                            }
                                        />
                                    )}
                                </Box>
                                {!showFeedbackBox && !isFeedbackSent && !isFinal && (
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        {!showRejectFeedbackBox && (
                                            <ReusableButton
                                                variant="contained"
                                                classNames="gn-actionbtn"
                                                sx={approveBtn}
                                                onClick={() => handleApproveDeliverable(i)}
                                                loader={loading.approveDeliverable}
                                                disabled={loading.approveDeliverable || loading.requestChanges || loading.rejectDeliverable}
                                            >
                                                Approve
                                            </ReusableButton>
                                        )}

                                        {i === 0 && !showRejectFeedbackBox && (
                                            <ReusableButton
                                                variant="contained"
                                                classNames="gn-actionbtn"
                                                onClick={handleRequestChangesClick}
                                                loader={loading.requestChanges}
                                                disabled={loading.approveDeliverable || loading.requestChanges}
                                            >
                                                Request Changes
                                            </ReusableButton>
                                        )}

                                        {!showRejectFeedbackBox &&
                                            !isFeedbackSent &&
                                            submission.status !== "rejected" &&
                                            i === 1 && (
                                                <ReusableButton
                                                    variant="contained"
                                                    classNames="gn-actionbtn"
                                                    onClick={handleRejectButtonClick}
                                                    loader={loading.rejectDeliverable}
                                                    disabled={loading.rejectDeliverable || loading.approveDeliverable}
                                                >
                                                    Reject
                                                </ReusableButton>
                                            )}

                                        {showRejectFeedbackBox && i === 1 && (
                                            <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 1 }}>
                                                <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#7A7A7A", mb: 0.5, }}>
                                                    Reason
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    label="Reason"
                                                    placeholder="Please specify the reason for rejection"
                                                    value={rejectFeedbackText}
                                                    onChange={(e) => {
                                                        setRejectFeedbackText(e.target.value);
                                                        if (e.target.value.trim()) {
                                                            setErrors((prev) => ({ ...prev, rejectFeedbackText: "" }));
                                                        }
                                                    }}
                                                    error={!!errors.rejectFeedbackText}
                                                    helperText={errors.rejectFeedbackText}
                                                    required
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ mb: 1, borderRadius: "16px", minWidth: { xs: '100%', md: '600px' } }}
                                                />
                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                    <ReusableButton variant="outlined" classNames="gn-actionbtn-outline gn-actionbtn-color" onClick={() => {
                                                        setRejectFeedbackText("");
                                                        setShowRejectFeedbackBox(false);
                                                    }} children={"Cancel"} disabled={loading.rejectDeliverable} />
                                                    <ReusableButton variant="outlined" classNames="gn-actionbtn" onClick={() => onRejectDeliverable(i)} loader={loading.rejectDeliverable} children={"Send"} />
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                )}

                                {showFeedbackBox && !isFeedbackSent && i === 0 && (
                                    <Box sx={{ mt: 1 }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                color: "#7A7A7A",
                                                mb: 2,
                                            }}
                                        >
                                            Reason
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={2}
                                            label="Reason"
                                            placeholder="Please specify the reason for rejection"
                                            value={feedbackText}
                                            onChange={(e) => {
                                                setFeedbackText(e.target.value);
                                                if (e.target.value.trim()) {
                                                    setErrors((prev) => ({ ...prev, feedbackText: "" }));
                                                }
                                            }}
                                            variant="outlined"
                                            size="small"
                                            sx={{ mb: 2, borderRadius: "16px" }}
                                            error={!!errors.feedbackText}
                                            helperText={errors.feedbackText}
                                            required
                                        />
                                        <Box sx={{ display: "flex", gap: 1 }}>
                                            <ReusableButton
                                                variant="outlined"
                                                classNames="gn-actionbtn-outline gn-actionbtn-color"
                                                onClick={() => {
                                                    setFeedbackText("");
                                                    setShowFeedbackBox(false);
                                                }}
                                                disabled={loading.sendFeedback}
                                            >
                                                Cancel
                                            </ReusableButton>

                                            <ReusableButton
                                                variant="outlined"
                                                classNames="gn-actionbtn"
                                                onClick={() => onSendFeedback(i)}
                                                loader={loading.sendFeedback}
                                            >
                                                Send
                                            </ReusableButton>
                                        </Box>
                                    </Box>
                                )}

                                {isExpanded &&
                                    ((i === 0 && parentDeliverable?.deliverable_reason) ||
                                        (i !== 0 && (submittedFeedbackTexts[i] || submission.reason))) && (
                                        <Box mt={2}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: "14px",
                                                    color: "#7A7A7A",
                                                    mb: 0.5,
                                                }}
                                            >
                                                Brand Feedback
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                                {i === 0
                                                    ? parentDeliverable?.deliverable_reason
                                                    : submittedFeedbackTexts[i] || submission.reason}
                                            </Typography>
                                        </Box>
                                    )}
                            </Box>
                        );
                    })
                    }
                </ContentBox >
            );
        }

        if (activeTab === "livepost") {
            const parentLinks = Array.isArray(applicationData?.live_links)
                ? applicationData.live_links
                : [];

            return (
                <>

                    <Box mt={2} sx={{ backgroundColor: "#fff", borderRadius: 2, boxShadow: 1, marginTop: '16px', p: 3 }} >
                        <CustomTabs
                            tabs={localTabs}
                            activeTab={activeTabs}
                            onTabChange={setActiveTabs}
                            arrow
                            tabLabels={{ Submission: 'Submission', 'Updated Submission': 'Updated Submission' }}
                        />
                        {(activeTabs === 'Submission' || activeTabs === 'Updated Submission') &&
                            parentLinks.map((parent, index) => {
                                const baseLink = activeTabs === 'Submission' ? parent : parent.child;
                                if (!baseLink) return null;
                                const {
                                    id,
                                    live_link,
                                    link_status,
                                    link_reason,
                                    link_name,
                                } = baseLink;

                                const statusColorMap = {
                                    "Approved": { bg: "#E0F7EA", color: "#219653" },
                                    "Rejected": { bg: "#FFEBEB", color: "#F14950" },
                                    "Need-changes": { bg: "#FFE3E4", color: "#EF5A56" },
                                };

                                const { bg, color } = statusColorMap[link_status] || { bg: "#eee", color: "#333" };

                                return (
                                    <Box key={id}>
                                        <Box sx={{ backgroundColor: "#f7f7f7", p: 2, borderLeft: "4px solid #F14950", borderRadius: "8px", mb: 3, mt: 2, display: "flex", flexDirection: "column", }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                {(savedReasons[id] || link_reason) && (
                                                    <IconButton size="small" onClick={() => toggleLiveExpand(index)} sx={{ p: 0 }}>
                                                        {expandedLiveIndexes.includes(index) ? <ExpandLess /> : <ExpandMore />}
                                                    </IconButton>
                                                )}
                                                <Typography sx={{ color: '#7A7A7A', fontSize: '16px' }}>
                                                    {link_name || `Link ${index + 1}`}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                                <Link
                                                    href={live_link}
                                                    target="_blank"
                                                    rel="noopener"
                                                    sx={{ textDecoration: 'none', fontSize: '16px' }}
                                                >
                                                    <ReusableMuiIcons name="launch" sx={{ color: '#7A7A7A' }} /> {live_link}
                                                </Link>
                                                {link_status && (<ReusableChip label={link_status} bgcolor={bg} color={color} />)}
                                            </Box>

                                            {!(
                                                (activeTabs === 'Submission' && (link_status === "Approved" || link_status === "Need-changes")) ||
                                                (activeTabs === 'Updated Submission' && (link_status === "Approved" || link_status === "Rejected"))
                                            ) && (<><Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={1}>
                                                <Typography sx={{ fontSize: '14px', color: '#7A7A7A', fontWeight: 600 }}>
                                                    Is this link valid?
                                                </Typography>
                                                <RadioGroup
                                                    row
                                                    value={
                                                        isValidMap[id] ??
                                                        (link_status === "Approved"
                                                            ? "Yes"
                                                            : link_status === "Need-changes" || link_status === "Rejected"
                                                                ? "No"
                                                                : "")
                                                    }
                                                    onChange={(e) => handleValidityChange(id, e.target.value)}
                                                >
                                                    <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" disabled={loadingMap[id]} />
                                                    <FormControlLabel value="No" control={<Radio size="small" />} label="No" disabled={loadingMap[id]} />
                                                </RadioGroup>
                                            </Box>

                                                {(isValidMap[id] === "No" ||
                                                    (!isValidMap[id] && (link_status === "Rejected" || link_status === "Need-changes"))) && (<Box>
                                                        <Typography sx={{ fontSize: '12px', color: '#7A7A7A' }}>Enter Reason *</Typography>
                                                        <TextField
                                                            fullWidth
                                                            multiline
                                                            rows={2}
                                                            placeholder="Please specify the reason for rejection"
                                                            variant="outlined"
                                                            size="small"
                                                            value={reasonMap[id] ?? link_reason ?? ""}
                                                            onChange={(e) => {
                                                                handleReasonChange(id, e.target.value);
                                                                if (e.target.value.trim()) {
                                                                    setErrors((prev) => ({
                                                                        ...prev,
                                                                        reasonMap: { ...prev.reasonMap, [id]: "" }
                                                                    }));
                                                                }
                                                            }}
                                                            error={!!errors.reasonMap[id]}
                                                            helperText={errors.reasonMap[id]}
                                                            required
                                                            sx={{ mt: 1, mb: 1, width: '331px', borderRadius: '16px' }}
                                                        />
                                                        <Box>
                                                            <ReusableButton children="Save" variant='outlibed' classNames={"gn-actionbtn-outline gn-actionbtn-color"} onClick={() => handleSaveReason(id, index)} loader={loadingMap[id]} disabled={loadingMap[id]} />
                                                        </Box>
                                                    </Box>)}</>
                                                )}
                                            {expandedLiveIndexes.includes(index) && (
                                                <Box mt={2}>
                                                    <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#7A7A7A", mb: 0.5 }}>
                                                        Brand Feedback
                                                    </Typography>
                                                    <Typography sx={{ fontSize: "14px", color: "#333" }}>
                                                        {savedReasons[id] || link_reason}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                );
                            })}
                    </Box>
                </>
            );
        }

        return null;
    };

    return renderTabContent();
};

export default TabsGigApplicationData;
